import { differenceInYears } from "date-fns";

async function getBadges(data: any) {
  return [
    {
      title: "La famiglia sta crescendo",
      blocked_text:
        "Sblocca questo badge inserendo la data di nascita prevista del tuo bambino.",
      unblocked_text:
        "Grazie per averci detto quando partorirai! In questo modo potrai ricevere comunicazioni mirate sul tema della gravidanza.",
      isUnlocked:
        data.value.estimateDateDelivery &&
        data.value.estimateDateDelivery !== "",
      imageSize: "w-[36px] h-[58px]",
      imageSrc: "images/badges/health-white.svg",
    },
    {
      title: "Una bella famiglia",
      unblocked_text:
        "Complimenti! Hai aggiornato il tuo profilo con i dati della tua famiglia.",
      blocked_text:
        "Aggiungi almeno un figlio al tuo profilo per sbloccare questo badge.",
      isUnlocked: data.value.children?.length > 0,
      imageSize: "w-[26px] h-[26px]",
      imageSrc: "images/badges/calendar-white.svg",
    },
    {
      title: "Restiamo in contatto",
      unblocked_text:
        "Grazie! Possiamo inviarti le nostre comunicazioni promozionali.",
      blocked_text:
        "Se ci rilasci il consenso marketing potremo mandarti comunicazioni e offerte imperdibili!",
      imageSrc: "images/badges/mail-white.svg",
      imageSize: "w-[25px] h-[20px]",
      isUnlocked: data.value.optIn1,
    },
    {
      title: "Pronto, chi parla?",
      blocked_text:
        "Per ricevere le nostre notizie via SMS e/o messaggi WhatsApp inserisci il numero di telefono.",
      unblocked_text:
        "Ottimo! Il tuo profilo è completo con il numero di telefono.",
      imageSrc: "images/badges/smartphone-white.svg",
      imageSize: "w-[21px] h-[31px]",
      isUnlocked: data.value.mobile !== "",
    },
    {
      title: "Casa dolce casa",
      unblocked_text: "Il tuo profilo è completo con il tuo indirizzo di casa.",
      blocked_text: "Il tuo profilo è completo con il tuo indirizzo di casa.",
      imageSrc: "images/badges/home-white.svg",
      imageSize: "w-[26px] h-[29px]",
      isUnlocked:
        data.value.postalCode !== "" ||
        data.value.province !== "" ||
        data.value.streetName !== "",
    },
    {
      title: "Una lunga relazione",
      blocked_text:
        "Tra poco festeggiamo un anno insieme! Continua a stare con noi.",
      unblocked_text: "Festeggiamo un anno insieme. Congratulazioni",
      imageSrc: "images/badges/award-white.svg",
      imageSize: "w-[21px] h-[58px]",
      isUnlocked:
        differenceInYears(Date.now(), new Date(data.value.registeredSince)) > 0,
    },
    // {
    //   title: "Opinion leader",
    //   blocked_text:
    //     "Se ci rilasci il consenso potremo chiedere la tua opinione con le nostre survey e sondaggi.",
    //   unblocked_text:
    //     "Possiamo chiedere la tua opinione con le nostre survey e sondaggi.",
    //   imageSrc: "images/badges/opinion-leader-white.svg",
    //   imageSize: "size-full",
    //   isUnlocked: data.value.optIn3,
    // },
    {
      title: "Extra-ordinario",
      unblocked_text:
        "Complimenti! Hai utilizzato almeno uno dei nostri vantaggi extra!",
      blocked_text:
        "Utilizza almeno uno dei nostri vantaggi extra per sbloccare questo badge.",
      imageSrc: "images/badges/extra-ordinary-badge-white.svg",
      imageSize: "size-full",
      isUnlocked: await getConsumedPromos(data.value.codiceCard),
    },
  ];
}

async function calculatePercentage(data: any) {
  let profileCards = [
    "Per ricevere le nostre offerte locali, inserisci il tuo indirizzo",
    "Per ricevere le nostre notizie via SMS e/o messaggi WhatsApp nserisci il numero di telefono",
    "Presta il tuo consenso privacy per ricevere le nostre comunicazioni e offerte personalizzate",
  ];

  let totalFields = 13;
  let completedFields = 6;

  if (data.optIn1 || data.optIn2 || data.optIn4) {
    profileCards.splice(2, 1);
  }
  if (data.optIn1) completedFields += 1;
  if (data.optIn2) completedFields += 1;
  if (data.optIn4) completedFields += 1;

  if (data.mobile) {
    completedFields += 1;
    profileCards.splice(1, 1);
  }

  if (data.streetName && data.province && data.postalCode) {
    profileCards.splice(0, 1);
  }
  if (data.streetName) completedFields += 1;
  if (data.province) completedFields += 1;
  if (data.postalCode) completedFields += 1;

  if (data?.children?.length > 0) {
    totalFields += 1;
    const childrenComplete = data.children.every(
      (child: any) => child.name && child.birthday && child.gender
    );
    if (childrenComplete) completedFields += 1;
  }

  const percentage = Math.round((completedFields / totalFields) * 100);

  return { percentage, profileCards };
}

async function getConsumedPromos(card_number: number) {
  const { data } = await useFetch("/api/badges", {
    method: "POST",
    body: {
      card_number: card_number,
    },
  });
  if (data.value) {
    return data.value.length;
  } else return false;
}

async function getVipBenefitSectionServices() {
  return [
    {
      title: "Promo Riservate",
      description:
        "Potrai accedere, in precisi momenti dell’anno, a una serie di promozioni dedicate ed esclusive.",
      icon: "images/services/coupon.svg",
    },
    {
      title: "Personal Shopper",
      description:
        "Servizio pensato per offrire un’esperienza di acquisto personalizzata e su misura per le esigenze dei clienti.",
      icon: "images/services/personal-shopper.svg",
    },
    {
      title: "Sconti pannolino",
      description:
        "Promozioni esclusive e convenienti sui pannolini delle migliori marche.",
      icon: "images/services/pannolini.svg",
    },
    // {
    //   title: "Regalo a distanza",
    //   description:
    //     "Questo servizio permette di recapitare gratuitamente un regalo al destinatario nel punto vendita a lui/lei più vicino.",
    //   icon: "images/services/regalo-distanca.svg",
    // },
    {
      title: "Punti doppi su specifici prodotti",
      description:
        "Possibilità di ottenere il doppio dei punti con l’acquisto di alcuni specifici prodotti a seconda del periodo dell’anno.",
      icon: "images/services/prenatal.svg",
    },
    {
      title: "Sconto compleanno",
      description:
        "Ogni anno, in occasione del tuo compleanno, riceverai uno sconto speciale da utilizzare sui tuoi acquisti.",
      icon: "images/services/birthday-cake.svg",
    },
    {
      title: "Vantaggi presso i partner",
      description:
        "Hai la possibilità di ottenere promozioni speciali, esclusive e sempre nuove in collaborazione con alcuni nostri partner.",
      icon: "images/services/vantaggi-dei-partners.svg",
    },
  ];
}

async function services() {
  return [
    {
      title: "Promo Riservate",
      description:
        "Potrai accedere, in precisi momenti dell’anno, a una serie di promozioni dedicate ed esclusive.",
      icon: "images/services/coupon.svg",
    },
    {
      title: "Personal Shopper",
      description:
        "Servizio pensato per offrire un’esperienza di acquisto personalizzata e su misura per le esigenze dei clienti.",
      icon: "images/services/personal-shopper.svg",
    },
    {
      title: "Regalo a distanza",
      description:
        "Questo servizio permette di recapitare gratuitamente un regalo al destinatario nel punto vendita a lui/lei più vicino.",
      icon: "images/services/regalo.svg",
    },
    {
      title: "Lista nascita",
      description:
        "Permette ai futuri genitori di creare una lista di regali con prodotti e articoli che desiderano, da condividere ai parenti per contribuire all’acquisto",
      icon: "images/services/lista-nascita.svg",
    },
    {
      title: "Kit Cicogna",
      description:
        "Puoi acquistare in un’unica soluzione tutto quello che occorre per dare al bimbo il più appropriato benvenuto ad un prezzo imbattibile.",
      icon: "images/services/kit-cicogna.svg",
    },
    {
      title: "Incontri nascere insieme",
      description:
        "Potrai partecipare a incontri dedicati alla gravidanza, alla preparazione del parto e alla cura del neonato.",
      icon: "images/services/incontri-nascere.svg",
    },
    {
      title: "Ritiro in negozio",
      description:
        "Potrei acquistare online e ricevere i prodotti direttamente in un negozio a scelta.",
      icon: "images/services/ritiro-negozio.svg",
    },
    {
      title: "Vantaggi dei Partners",
      description:
        "Hai la possibilità di ottenere promozioni speciali, esclusive e sempre nuove in collaborazione con alcuni nostri partner",
      icon: "images/services/vantaggi-dei-partners.svg",
    },
    {
      title: "Prenotazioni",
      description:
        "Puoi prenotare in negozio i prodotti per la prima infanzia e gioco desiderati e non immediatamente disponibili e riceverli comodamente a casa o ritirarli in negozio",
      icon: "images/services/prenotazioni.svg",
    },
    {
      title: "Sconto compleanno del titolare della card",
      description:
        "Ogni anno, in occasione del tuo compleanno, riceverai uno sconto speciale da utilizzare sui tuoi acquisti.",
      icon: "images/services/birthday-cake.svg",
    },
    {
      title: "Punti doppi su specifici prodotti",
      description:
        "Ottieni il doppio dei punti con l’acquisto di specifici prodotti in alcuni periodi dell’anno.",
      icon: "images/services/prenatal.svg",
    },
    {
      title: "Sconti pannolino",
      description:
        "Promozioni esclusive e convenienti sui pannolini delle migliori marche",
      icon: "images/services/pannolini.svg",
    },
  ];
}

async function goldServices(
  standard_return_period: number,
  gold_return_period: number
) {
  return [
    {
      title: "Consegna a domicilio scontata da negozio e online",
      description:
        "Il vantaggio di avere uno sconto sui costi di consegna sia per gli acquisti in negozio sia per quelli online.",
      icon: "images/services/ritiro-negozio.svg",
    },
    {
      title: "Sconto 20% sul noleggio tiralatte",
      description:
        "Potrai ottenere a un prezzo scontato il noleggio del tiralatte.",
      icon: "images/services/biberon.svg",
    },
    {
      title: "Cambio merce prolungato",
      description: `Il periodo per il cambio merce si estende da ${standard_return_period} a ${gold_return_period} giorni per offrire ai clienti Prénatal Lover Gold più tempo per decidere se desiderano restituire o cambiare un prodotto acquistato.`,
      goldDescription: `Cambio merce esteso da ${standard_return_period} a ${gold_return_period} giorni: hai più tempo per decidere se restituire o cambiare un prodotto`,
      icon: "images/services/clothes-hanger.svg",
    },
    {
      title: "Accesso anticipato a specifiche promo",
      description:
        "Potrai accedere a specifiche promozioni speciali di Prénatal anticipatamente rispetto al pubblico generale.",
      icon: "images/services/coupon.svg",
    },
    // {
    //   title: "Customer care prioritario",
    //   description:
    //     "Otterrai assistenza con priorità rispetto agli altri utenti, per garantirti una migliore esperienza post-vendita.",
    //   icon: "images/services/prenatal.svg",
    // },
    {
      title: "Pediatra gratuito dedicato per 2 mesi",
      description:
        "Possibilità di usufruire gratuitamente di un pediatra on line dedicato 24 ore su 24 e 7 giorni su 7 in collaborazione con il partner Elty",
      icon: "images/services/pediatra.svg",
    },
    {
      title: "Vantaggi aggiuntivi con i Partners",
      description:
        "Avrai la possibilità di ottenere ulteriori sconti e promozioni speciali ed esclusive dedicate ai clienti Prénatal Lover Gold in collaborazione con specifici partners.",
      icon: "images/services/vantaggi-dei-partners.svg",
    },
    {
      title: "Sconto compleanno figlio",
      description:
        "Ogni anno, in occasione del compleanno di tu* figl*, riceverai uno sconto speciale da utilizzare sui tuoi acquisti.",
      icon: "images/services/birthday-cake.svg",
    },
    {
      title: "Punti extra su specifiche attività",
      description: "Ad esempio completo i sondaggi e accumulo più punti",
      icon: "images/services/extra-activity.svg",
    },
  ];
}

export {
  calculatePercentage,
  getBadges,
  services,
  goldServices,
  getVipBenefitSectionServices,
};
